import React from 'react'
import { Full as Loading } from 'components/Loading'
import TemplateList from './../../components/TemplateList'
import useApi from 'hooks/useApi'
import messages from './messages'
import { FormattedMessage, useIntl } from 'react-intl'

const TemplatePage = () => {
  const [templates, loading, errors] = useApi('/rest/v2/template')

  return (
    <div className="py-3 px-4 lg:py-5 lg:px-6 space-y-6 flex flex-col h-full w-full">
      <div className="pb-5 border-b border-gray-200">
        <h3 className="text-lg leading-6 font-medium text-gray-900">
          <FormattedMessage{...messages.newOrderTitle}/>
        </h3>
        <p className="mt-2 max-w-4xl text-sm text-gray-500"><FormattedMessage{...messages.newOrderBody}/></p>
      </div>

      { loading || !templates ? (
        <Loading children={errors || undefined} />
      ) : (
        <div className="grow flex justify-center items-center">
          <TemplateList templates={templates} />
        </div>
      ) }
    </div>
  )
}

export default TemplatePage
